import React from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import SosHomeActivitiesGraph from "./sos-home-activities-graph.jsx";
import SosHomeLifeRisk from "./sos-home-life-risk.jsx";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {DASH_BREAKPOINTS} from "../../../../../utils/responsive-graph.js";

const SosHomeProtected = ({data, hasEventPermission}) => {
    const vw = useGraphViewportWidth();
    const isCompact = vw < DASH_BREAKPOINTS.desktop;

    const aggressorsFs =  isCompact ? "text-(length:--font-md)!" : "text-[20px]!"

    return (
        <Card className={"flex flex-col " + (hasEventPermission ? "col-span-3" : "col-span-4")}>
            <Card.Header className={"bg-[#031B35]!"}>
                <Card.Title className={"text-white text-[18px]!"}>Protegidos</Card.Title>
            </Card.Header>
            <Card.Body className={"flex-1 min-h-0 bg-linear-to-b from-white to-[#EDF6FF] grid gap-2 p-3 " + (isCompact ? "grid-cols-[2fr_3fr_2fr]" : "grid-cols-[2fr_4fr_2fr]")}>

                <section className="min-h-0 overflow-hidden flex flex-col items-center font-sans px-2 py-2 border-r border-[#EBEBEB]">
                    <div className="flex-1 min-h-0 w-full flex items-center justify-center overflow-hidden [container-type:size]">
                        <div className="relative aspect-square w-[min(79cqw,100cqh)]">
                            <div
                                className="absolute inset-0 rounded-full border-2 box-border"
                                style={{ borderColor: "#C7DCEF" }}
                                aria-hidden="true"
                            />

                            <div
                                className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[88%] aspect-square rounded-full flex flex-col items-center justify-start pt-[10%]"
                                style={{ background: "#C9DEF3" }}
                            >
                                <div
                                    className="text-(length:--font-xl) font-medium leading-none"
                                    style={{ color: "#0C447C" }}
                                >
                                    {data?.citizenCount ?? 0}
                                </div>
                                <div
                                    className={"text-center mt-1 leading-tight text-[clamp(9px,0.9vw,14px)]"}
                                    style={{ color: "#185FA5" }}
                                >
                                    Protegidos cadastrados
                                </div>
                            </div>

                            <div
                                className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[47%] aspect-square rounded-full flex flex-col items-center justify-center"
                                style={{ background: "#92BEE6" }}
                            >
                                <div
                                    className="text-(length:--font-xl) font-medium leading-none"
                                    style={{ color: "#042C53" }}
                                >
                                    {data?.citizensActive ?? 0}
                                </div>
                                <div
                                    className={"text-center mt-1 leading-tight text-[clamp(9px,0.9vw,14px)]"}
                                    style={{ color: "#0C447C" }}
                                >
                                    Protegidos
                                    <br />
                                    ativos
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-3 pl-1 w-full shrink-0 justify-center">
                        <div
                            className="w-0.75 h-6 shrink-0"
                            style={{ background: "#3B6D8E" }}
                            aria-hidden="true"
                        />
                        <span
                            className={["font-medium", aggressorsFs].join(" ")}
                            style={{ color: "#2C2C2A" }}
                        >
                          {data?.aggressorCount ?? 0}
                        </span>
                        <span
                            className={aggressorsFs}
                            style={{ color: "#5F5E5A" }}
                        >
                          Agressores cadastrados
                        </span>
                    </div>
                </section>

                <section className={"border-r-2 border-[#EBEBEB] pr-2"}>
                    <SosHomeActivitiesGraph data={data} />
                </section>

                <SosHomeLifeRisk data={data} />

            </Card.Body>
        </Card>
    );
};

export default SosHomeProtected;